/* =========================================================
   FIXD v4 — Theme JavaScript
   Psychology-driven: viewer counter, number reveal, urgency,
   scroll reveal, parallax, hero rotator, ticker duplication,
   AJAX cart, mobile nav, accordions, gallery.
   ========================================================= */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Mobile nav ── */
  function initMobileNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var nav = document.querySelector('[data-site-nav]');
    var overlay = document.querySelector('[data-nav-overlay]');
    if (!toggle || !nav) return;
    function close() { nav.classList.remove('is-open'); if (overlay) overlay.classList.remove('is-open'); toggle.setAttribute('aria-expanded','false'); }
    function open() { nav.classList.add('is-open'); if (overlay) overlay.classList.add('is-open'); toggle.setAttribute('aria-expanded','true'); }
    toggle.addEventListener('click', function () { nav.classList.contains('is-open') ? close() : open(); });
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ── Header glass on scroll ── */
  function initHeaderScroll() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    function update() { header.classList.toggle('is-scrolled', window.scrollY > 20); }
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  /* ── Scroll reveal ── */
  function initScrollReveal() {
    var items = document.querySelectorAll('[data-animate]');
    if (!items.length) return;
    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var seenParents = new Map();
    items.forEach(function (el) {
      var parent = el.parentElement;
      var count = seenParents.get(parent) || 0;
      el.style.setProperty('--d', Math.min(count * 0.08, 0.5) + 's');
      seenParents.set(parent, count + 1);
    });
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });
    items.forEach(function (el) { observer.observe(el); });
  }

  /* ── Parallax liquid shapes ── */
  function initParallax() {
    if (prefersReducedMotion) return;
    var layers = document.querySelectorAll('[data-parallax-speed]');
    if (!layers.length) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      layers.forEach(function (el) {
        var speed = parseFloat(el.getAttribute('data-parallax-speed')) || 0.1;
        var rect = el.parentElement.getBoundingClientRect();
        var center = rect.top + rect.height / 2 - vh / 2;
        el.style.transform = 'translateY(' + (center * speed * -1) + 'px)';
      });
      ticking = false;
    }
    function onScroll() { if (!ticking) { requestAnimationFrame(update); ticking = true; } }
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  /* ── Hero rotating hook word — psychology: novelty = attention ── */
  function initHeroRotator() {
    var rotator = document.querySelector('[data-hero-rotator]');
    if (!rotator || prefersReducedMotion) return;
    var words = JSON.parse(rotator.getAttribute('data-words') || '[]');
    if (words.length < 2) return;
    var current = 0;
    var wordEl = rotator.querySelector('.hero__rotator-word');
    if (!wordEl) return;
    setInterval(function () {
      current = (current + 1) % words.length;
      wordEl.classList.add('is-leaving');
      setTimeout(function () {
        wordEl.textContent = words[current];
        wordEl.classList.remove('is-leaving');
        wordEl.classList.add('is-entering');
        void wordEl.offsetWidth;
        wordEl.classList.remove('is-entering');
      }, 350);
    }, 2800);
  }

  /* ── Hook ticker — duplicate for seamless loop ── */
  function initHookTicker() {
    document.querySelectorAll('[data-hook-ticker-track]').forEach(function (track) {
      if (track.dataset.duplicated) return;
      track.innerHTML += track.innerHTML;
      track.dataset.duplicated = 'true';
    });
  }

  /* ── Viewer counter — psychology: social proof, scarcity ── */
  function initViewerCounter() {
    var el = document.querySelector('[data-viewer-count]');
    if (!el) return;
    var base = parseInt(el.getAttribute('data-viewer-base') || '24', 10);
    var current = base + Math.floor(Math.random() * 8);
    el.textContent = current + ' people viewing this now';
    // Randomly increment/decrement to feel live
    setInterval(function () {
      var delta = Math.random() < 0.55 ? 1 : -1;
      current = Math.max(12, Math.min(current + delta, base + 15));
      el.textContent = current + ' people viewing this now';
    }, 4500);
  }

  /* ── Animated number reveal — psychology: specificity = trust ── */
  function initNumberReveal() {
    if (prefersReducedMotion) return;
    var counters = document.querySelectorAll('[data-count-to]');
    if (!counters.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseInt(el.getAttribute('data-count-to'), 10);
        var suffix = el.getAttribute('data-count-suffix') || '';
        var duration = 1400;
        var start = performance.now();
        function step(now) {
          var progress = Math.min((now - start) / duration, 1);
          var ease = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.floor(ease * target).toLocaleString() + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        observer.unobserve(el);
      });
    }, { threshold: 0.5 });
    counters.forEach(function (el) { observer.observe(el); });
  }

  /* ── Qty selectors ── */
  function initQuantitySelectors() {
    document.querySelectorAll('[data-qty-selector]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      var minus = wrap.querySelector('[data-qty-minus]');
      var plus = wrap.querySelector('[data-qty-plus]');
      if (!input) return;
      if (minus) minus.addEventListener('click', function () { var v = Math.max(1,(parseInt(input.value,10)||1)-1); input.value=v; input.dispatchEvent(new Event('change',{bubbles:true})); });
      if (plus) plus.addEventListener('click', function () { var v=(parseInt(input.value,10)||1)+1; input.value=v; input.dispatchEvent(new Event('change',{bubbles:true})); });
    });
  }

  /* ── Accordions ── */
  function initAccordions() {
    document.querySelectorAll('[data-accordion-item]').forEach(function (item) {
      var trigger = item.querySelector('[data-accordion-trigger]');
      var panel = item.querySelector('[data-accordion-panel]');
      if (!trigger || !panel) return;
      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open', !isOpen);
        trigger.setAttribute('aria-expanded', String(!isOpen));
        panel.style.maxHeight = !isOpen ? panel.scrollHeight + 'px' : '0px';
      });
    });
  }

  /* ── Product gallery ── */
  function initGalleries() {
    document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main-img]');
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-full-src');
          if (main && src) main.src = src;
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  /* ── Variant swatch state ── */
  function initSwatches() {
    document.querySelectorAll('.swatch-list').forEach(function (list) {
      list.querySelectorAll('input[type="radio"]').forEach(function (input) {
        input.addEventListener('change', function () {
          list.querySelectorAll('label').forEach(function (l) { l.classList.remove('is-checked'); });
          if (input.checked) input.closest('label').classList.add('is-checked');
        });
      });
    });
  }

  /* ── Cart count update ── */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  /* ── Cart notification popup ── */
  function showCartNotification(html) {
    var existing = document.querySelector('[data-cart-notification]');
    if (existing) existing.remove();
    var wrap = document.createElement('div');
    wrap.className = 'cart-notification glass-hi';
    wrap.setAttribute('data-cart-notification', '');
    wrap.innerHTML = html;
    document.body.appendChild(wrap);
    requestAnimationFrame(function () { wrap.classList.add('is-visible'); });
    var closeBtn = wrap.querySelector('[data-cart-notification-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { wrap.classList.remove('is-visible'); });
    setTimeout(function () { wrap.classList.remove('is-visible'); }, 5500);
  }

  /* ── AJAX add to cart ── */
  function initAddToCartForms() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var submitBtn = form.querySelector('[type="submit"]');
        var formData = new FormData(form);
        if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.orig = submitBtn.textContent; submitBtn.textContent = 'Adding…'; }
        fetch('/cart/add.js', { method:'POST', body:formData, headers:{Accept:'application/json'} })
          .then(function (res) { if (!res.ok) return res.json().then(function (e) { throw e; }); return res.json(); })
          .then(function (item) {
            return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
              updateCartCount(cart.item_count);
              var img = item.featured_image ? item.featured_image.url : (item.image||'');
              showCartNotification(
                '<div class="cart-notification__head">Added to cart <button data-cart-notification-close aria-label="Close" style="background:none;border:none;font-size:20px;cursor:pointer;color:var(--ink-muted);">&times;</button></div>' +
                '<div class="cart-notification__product">' + (img?'<img src="'+img+'" alt="">':'') +
                '<div><div style="font-weight:700;font-size:13px;color:var(--ink);">'+item.product_title+'</div>' +
                '<div style="font-family:var(--font-mono);font-size:11px;color:var(--ink-muted);">Qty '+item.quantity+'</div></div></div>' +
                '<div class="cart-notification__actions"><a class="btn btn--glass" href="/cart" style="text-decoration:none;font-size:12.5px;">View cart</a><a class="btn btn--primary" href="/checkout" style="text-decoration:none;font-size:12.5px;">Checkout</a></div>'
              );
            });
          })
          .catch(function (err) {
            var msg = (err&&err.description)||'Could not add to cart.';
            showCartNotification('<div class="cart-notification__head">Heads up <button data-cart-notification-close style="background:none;border:none;font-size:20px;cursor:pointer;">&times;</button></div><div style="font-size:13px;color:var(--ink-soft);">'+msg+'</div>');
          })
          .finally(function () { if (submitBtn) { submitBtn.disabled=false; submitBtn.textContent=submitBtn.dataset.orig||'Add to cart'; } });
      });
    });
  }

  /* ── Cart line quantity change ── */
  function initCartLineUpdates() {
    document.querySelectorAll('[data-cart-line-qty]').forEach(function (input) {
      input.addEventListener('change', function () {
        var key = input.getAttribute('data-cart-line-qty');
        var qty = Math.max(0, parseInt(input.value,10)||0);
        fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id:key,quantity:qty}) })
          .then(function () { window.location.reload(); });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initHeaderScroll();
    initScrollReveal();
    initParallax();
    initHeroRotator();
    initHookTicker();
    initViewerCounter();
    initNumberReveal();
    initQuantitySelectors();
    initAccordions();
    initGalleries();
    initSwatches();
    initAddToCartForms();
    initCartLineUpdates();
  });
})();

/* Ambient background — scroll link */
(function () {
  var bg = document.querySelector('.ambient-bg');
  if (!bg) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var ticking = false;
  function update() {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    var p = max > 0 ? window.scrollY / max : 0;
    bg.style.setProperty('--scroll', p);
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();
})();